(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  if (!customElements.get('comfortari-round-menu')) {
    customElements.define('comfortari-round-menu', class extends HTMLElement {
      connectedCallback() {
        this.disclosure = this.querySelector('.cf-menu__details');
        this.toggle = this.querySelector('.cf-menu__toggle');
        this.section = this.closest('.shopify-section');
        if (!this.disclosure || !this.toggle || !this.section) return;
        this.controller = new AbortController();
        const signal = this.controller.signal;
        this.frame = 0;
        const updatePosition = () => {
          this.frame = 0;
          // Follow the announcement bar initially, then stay near the viewport top.
          const top = Math.max(12, this.section.getBoundingClientRect().top + 12);
          this.style.setProperty('--cf-top', `${Math.round(top)}px`);
        };
        const schedulePosition = () => {
          if (!this.frame) this.frame = requestAnimationFrame(updatePosition);
        };
        this.close = (restoreFocus = false) => {
          this.disclosure.open = false;
          if (restoreFocus) this.toggle.focus();
        };
        this.disclosure.addEventListener('toggle', () => {
          this.toggle.setAttribute('aria-expanded', String(this.disclosure.open));
        }, { signal });
        this.toggle.setAttribute('aria-expanded', String(this.disclosure.open));
        document.addEventListener('click', (event) => {
          if (this.disclosure.open && !this.contains(event.target)) this.close();
        }, { signal });
        this.addEventListener('keydown', (event) => {
          if (event.key === 'Escape' && this.disclosure.open) {
            event.preventDefault();
            event.stopPropagation();
            this.close(true);
          }
        }, { signal });
        this.addEventListener('focusout', (event) => {
          if (event.relatedTarget && !this.contains(event.relatedTarget)) this.close();
        }, { signal });
        this.addEventListener('click', (event) => {
          if (event.target.closest('a[href]')) this.close();
        }, { signal });
        window.addEventListener('scroll', schedulePosition, { passive: true, signal });
        window.addEventListener('resize', schedulePosition, { passive: true, signal });
        window.addEventListener('pageshow', () => { this.close(); schedulePosition(); }, { signal });
        if (window.visualViewport) {
          window.visualViewport.addEventListener('resize', schedulePosition, { signal });
        }
        this.resizeObserver = new ResizeObserver(schedulePosition);
        this.resizeObserver.observe(document.body);
        this.resizeObserver.observe(this.section.parentElement);
        document.documentElement.style.setProperty('--header-height', '0px');
        updatePosition();
      }
      disconnectedCallback() {
        this.controller?.abort();
        this.resizeObserver?.disconnect();
        if (this.frame) cancelAnimationFrame(this.frame);
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
